module.exports = __webpack_public_path__ + "static/media/modulo_evasione_con_altri_mezzi.d4d09f33.pdf";